// extracted by mini-css-extract-plugin
module.exports = {"deleteFeed":"styles_deleteFeed__3mPQ-"};